import { render } from "./CapitalCardRWA.vue?vue&type=template&id=d13e5d08&scoped=true"
import script from "./CapitalCardRWA.vue?vue&type=script&lang=js"
export * from "./CapitalCardRWA.vue?vue&type=script&lang=js"

import "./CapitalCardRWA.vue?vue&type=style&index=0&id=d13e5d08&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13e5d08"]])

export default __exports__